export default __webpack_public_path__ + "static/media/Yellow0003.bf905ca7.png";